import { CardContent, CardHeader, CardTitle } from '@ui/card.tsx';
import { Skeleton } from '@ui/skeleton.tsx';

export function DataBrickSkeleton({ size = 'small' }: { size?: 'small' | 'large' }) {
  const content = (
    <Skeleton className="flex flex-col h-full bg-transparent border-2 rounded-3xl border-muted">
      <CardHeader className="space-y-0">
        <CardTitle className="flex items-center space-x-2">
          <div className="mr-2 rounded-md aspect-square h-7 bg-muted" />
          <div className="w-full mr-2 rounded-md h-7 bg-muted" />
        </CardTitle>
      </CardHeader>

      <CardContent className="flex flex-col">
        <div className="w-3/12 mb-2 mr-2 rounded-md h-9 bg-muted" />
        <div className="w-8/12 h-5 mr-2 rounded-md bg-muted" />
      </CardContent>
    </Skeleton>
  );

  switch (size) {
    case 'small':
      return <div className="w-full h-fit 2xl:h-full 2xl:w-6/12">{content}</div>;
    case 'large':
      return <div className="w-full h-fit">{content}</div>;
  }
}
